import { useState, useEffect } from 'react';
import { apiCall } from '../api/client';
import type { Status } from '../api/types';

const STATUS_POLL_INTERVAL_MS = 10000; // 10 seconds (hardcoded)

export function useStatus(refreshInterval = STATUS_POLL_INTERVAL_MS) {
  const [data, setData] = useState<Status | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchStatus = async () => {
    try {
      const status = await apiCall<Status>('/status');
      setData(status);
      setError(null);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatus();

    if (refreshInterval > 0) {
      const interval = setInterval(fetchStatus, refreshInterval);
      return () => clearInterval(interval);
    }
  }, [refreshInterval]);

  return { data, loading, error, refetch: fetchStatus };
}
